import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 30px;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
`;

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;
	pointer-events: none;

	& > ${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

export { StyledButtonsContainer, StyledModalBody, StyledPrice, StyledRow };
